import { render, staticRenderFns } from "./SfImage.vue?vue&type=template&id=da87b454&"
import script from "./SfImage.vue?vue&type=script&lang=js&"
export * from "./SfImage.vue?vue&type=script&lang=js&"
import style0 from "./SfImage.vue?vue&type=style&index=0&id=da87b454&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports